import { render, staticRenderFns } from "./optionalGeneral.vue?vue&type=template&id=31a78ef2"
import script from "./optionalGeneral.vue?vue&type=script&lang=js"
export * from "./optionalGeneral.vue?vue&type=script&lang=js"
import style0 from "./optionalGeneral.vue?vue&type=style&index=0&id=31a78ef2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports